import React, { FunctionComponent, ReactElement } from "react";
import { Box, Breakpoint, DialogActions, DialogContent, Toolbar } from "@mui/material";
import { strings } from "../../localization/LocalizedStrings";
import { ContainedButton } from "../ContainedButton";
import styles from "./styles.module.scss";
import { ToolbarButton } from "../toolbar/ToolbarButton";
import { PiperDialog } from "../PiperDialog";
import { IconType } from "../../icons";

export const AlertDialog: FunctionComponent<IAlertDialogProps> = ({
  title,
  message,
  isConfirm,
  open,
  setOpen,
  onConfirm,
  onCancel,
  confirmTitle,
  cancelTitle,
  helpLink,
  link,
  imageUrl,
  linkButtonText,
  hasCloseButton,
  maxWidth
}) => {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <PiperDialog open={open} maxWidth={maxWidth}>
      <Toolbar>
        <h3>{title ?? strings.app_name}</h3>
        <Box flexGrow={1} />
        {helpLink && (
          <ToolbarButton
            href={`${window.location.protocol}//${window.location.host}${helpLink}`}
            target={"_blank"}
            tooltip={strings.help}
            iconType={IconType.Help}
          />
        )}
        {hasCloseButton && (
          <ToolbarButton onClick={handleClose} tooltip={strings.close} iconType={IconType.Close} />
        )}
      </Toolbar>
      <DialogContent sx={{ paddingTop: 0, paddingBottom: 0 }}>
        <p className={styles.message}>{message}</p>
        {link && (
          <ContainedButton className={styles.moreInfoButton} href={link}>
            {linkButtonText ?? strings.more_info}
          </ContainedButton>
        )}
        {imageUrl && <img className={styles.imageAttachment} src={imageUrl} alt={"Attachment"} />}
      </DialogContent>
      <DialogActions>
        {isConfirm && (
          <ContainedButton
            className={styles.button}
            onClick={() => {
              if (onCancel) {
                onCancel();
              }
              handleClose();
            }}
          >
            {cancelTitle ?? strings.alert_cancel}
          </ContainedButton>
        )}
        {!hasCloseButton && (
          <ContainedButton
            className={styles.button}
            onClick={() => {
              if (onConfirm) {
                onConfirm();
              }
              handleClose();
            }}
          >
            {isConfirm ? confirmTitle ?? strings.alert_confirm : strings.alert_accept}
          </ContainedButton>
        )}
      </DialogActions>
    </PiperDialog>
  );
};

export interface IAlertDialogProps {
  title?: string;
  message: string | ReactElement;
  isConfirm?: boolean;
  open: boolean;
  setOpen: (state: boolean) => void;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmTitle?: string;
  cancelTitle?: string;
  helpLink?: string;
  link?: string;
  imageUrl?: string;
  linkButtonText?: string;
  hasCloseButton?: boolean;
  maxWidth?: Breakpoint;
}
